// Meetings API client. All calls are proxied through the CRM backend.
import axios from "axios";
import { API } from "@/App";

function authHdr() {
  const token = localStorage.getItem("token") || "";
  return { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
}

export async function createMeeting(payload) {
  const r = await axios.post(`${API}/meetings`, payload, { headers: authHdr() });
  return r.data;
}

export async function listMeetings(filters = {}) {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== null && v !== "") params.set(k, v);
  }
  const url = `${API}/meetings${params.toString() ? "?" + params.toString() : ""}`;
  const r = await axios.get(url, { headers: authHdr() });
  return r.data;
}

export async function getMeeting(id) {
  const r = await axios.get(`${API}/meetings/${id}`, { headers: authHdr() });
  return r.data;
}

export async function patchMeeting(id, patch) {
  const r = await axios.patch(`${API}/meetings/${id}`, patch, { headers: authHdr() });
  return r.data;
}

export async function cancelMeeting(id, reason) {
  const r = await axios.post(`${API}/meetings/${id}/cancel`, { reason }, { headers: authHdr() });
  return r.data;
}

export async function markMeetingNoShow(id, note) {
  const r = await axios.post(`${API}/meetings/${id}/mark-no-show`, { note }, { headers: authHdr() });
  return r.data;
}

